// extracted by mini-css-extract-plugin
module.exports = {"defaultBackground":"var(--btn-bg-2)","loader":"src-pages-News-components-Selections-styles__loader"};